import React from 'react';
import {
  MembershipIcon,
  ProgressIcon,
  CertificateIcon,
  EditIcon,
  DownloadIcon,
  LogoutIcon,
  SettingsIcon,
  EnterpriseIcon,
  StarIcon,
} from '../../../assets/icons';
import { isEnterprise } from '../../../config';

const NAV_ITEMS = [
  {
    key: 'core',
    label: 'Core Curriculum',
  },
  {
    path: '/programs',
    key: 'additional_resources',
    label: 'All Curricula',
  },
  {
    path: 'https://www.adventuresincre.com',
    key: 'acre',
    label: 'A.CRE',
    external: true,
  },
];

const MANAGER_NAV_ITEMS = [
  {
    path: 'https://www.adventuresincre.com',
    key: 'acre',
    label: 'A.CRE',
    external: true,
  },
];

const MANAGER_MENU_ITEMS = [
  {
    type: 'item',
    path: '/manage',
    key: 'enterprise-dashboard',
    label: 'Enterprise Dashboard',
    icon: <EnterpriseIcon className="mr-2" />,
  },
  // {
  //   type: 'item',
  //   path: '/profile',
  //   key: 'my-account',
  //   label: 'Edit Account Details',
  //   icon: <EditIcon className="mr-2" />,
  // },
  // {
  //   type: 'item',
  //   path: '/logout',
  //   key: 'logout',
  //   label: 'Log out',
  //   icon: <LogoutIcon className="mr-2" />,
  // },
];

const MENU_ITEMS = [
  {
    type: 'item',
    path: '/membership',
    key: 'membership',
    label: 'Membership Details',
    icon: <MembershipIcon className="mr-2" />,
  },
  {
    type: 'item',
    path: '/progress',
    key: 'my-progress',
    label: 'Program Progress',
    icon: <ProgressIcon className="mr-2" />,
  },
  {
    type: 'item',
    path: '/certificate',
    key: 'certificate-completion',
    label: 'Certificate of Completion',
    icon: <CertificateIcon className="mr-2" />,
  },
  {
    type: 'item',
    path: isEnterprise
      ? '/profile'
      : 'https://www.adventuresincre.com/my-account/edit-account',
    key: 'my-account',
    label: 'Edit Account Details',
    icon: <EditIcon className="mr-2" />,
    external: !isEnterprise,
  },
  {
    type: 'item',
    path: 'https://www.adventuresincre.com/my-account/downloads',
    key: 'download-acre',
    label: 'My A.CRE Downloads',
    external: true,
    icon: <DownloadIcon className="mr-2" />,
    hidden: isEnterprise,
  },
  {
    type: 'item',
    path: 'https://www.adventuresincre.com/accelerator-introduction/#version',
    key: 'whatsnew',
    label: "See What's New",
    external: true,
    icon: <StarIcon className="mr-2" />,
    hidden: isEnterprise,
  },
  {
    type: 'item',
    path: '/settings',
    key: 'settings',
    label: 'Settings',
    icon: <SettingsIcon className="mr-2" />,
  },
  {
    type: 'item',
    path: '/logout',
    key: 'logout',
    label: 'Log out',
    icon: <LogoutIcon className="mr-2" />,
  },
];

export { NAV_ITEMS, MENU_ITEMS, MANAGER_MENU_ITEMS, MANAGER_NAV_ITEMS };
